export function logAppVersion(event = "") {
  const buildTime = process.env.VUE_APP_BUILD_TIME || "Unknown";
  const commit = process.env.VUE_APP_GIT_COMMIT
    ? ` (${process.env.VUE_APP_GIT_COMMIT})`
    : "";
  const prefix = event ? `[${event}] ` : "";

  console.log(
    `%c[CARGO WKJT]%c ${prefix}Last Update: ${buildTime}${commit}`,
    "background: #1976D2; color: #fff; padding: 3px 8px; border-radius: 4px; font-weight: bold; font-size: 11px;",
    "color: #1976D2; font-weight: bold; font-size: 11px; margin-left: 4px;"
  );
}
